export default function Loader() {
  return (
    <div className="spinner-border text-primary m-5" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
